import { Controller } from "@hotwired/stimulus"

// The expandable weekend row on the racing discover list.
//
// Open state is persisted to localStorage and restored in connect(), not left
// as a bare class toggle. The row is full of controls that redirect — follow,
// skip, notify — and a Turbo redirect re-renders the list from the server, at
// which point the panel would snap back to its default `hidden`. That reads as
// "the card collapsed when I clicked the button inside it", and no amount of
// stopPropagation fixes it, because the event was never the cause.
//
// Keyed by event id rather than list position so the right row reopens after
// the collection changes (a new page appended, a filter applied).
export default class extends Controller {
  static targets = ["panel", "chevron", "summary"]
  static values = { id: String }

  connect() {
    if (this.idValue && localStorage.getItem(this.storageKey) === "open")
      this.open()
  }

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.chevronTarget?.classList.add("rotate-90")
    this.summaryTarget?.setAttribute("aria-expanded", "true")
    if (this.idValue) localStorage.setItem(this.storageKey, "open")
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.chevronTarget?.classList.remove("rotate-90")
    this.summaryTarget?.setAttribute("aria-expanded", "false")
    if (this.idValue) localStorage.removeItem(this.storageKey)
  }

  get storageKey() {
    return `racing-event-row:${this.idValue}`
  }
}
